import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DataTableComponent } from './shared/components/data-table/data-table.component';
import { EquipmentComponent } from './pages/master/equipment/equipment.component';
import { SystemComponent } from './pages/master/system/system.component';
import { UserComponent } from './pages/master/user/user.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProposalComponent } from './pages/master/proposal/proposal.component';
import { SchemeComponent } from './pages/master/scheme/scheme.component';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { AuthChildGuard } from './guards/auth-child.guard';
import { KmpComponent } from './pages/master/kmp/kmp.component';
import { PropogalDashboardComponent } from './pages/dashboard/propogal-dashboard/propogal-dashboard.component';

import { UserProfileComponent } from './shared/components/user-profile/user-profile.component';
import { UserDetailsComponent } from './shared/components/user-details/user-details.component';
import { UserMappingComponent } from './shared/components/user-mapping/user-mapping.component';

import { UnitComponent } from './pages/master/unit/unit.component';
import { FundComponent } from './pages/master/fund/fund.component';
import { AccessPrivilegeComponent } from './shared/components/access-privilege/access-privilege.component';
import { IdexComponent } from './pages/idex/idex.component';
import { TransactionIdexComponent } from './pages/transaction-idex/transaction-idex.component';
import { EoiMasterComponent } from './pages/master/eoi-master/eoi-master.component';
import { MakeITransactionComponent } from './pages/make-i-transaction/make-i-transaction.component';
import { MakeIiTransactionComponent } from './pages/make-ii-transaction/make-ii-transaction.component';
import { PocMasterComponent } from './pages/master/poc-master/poc-master.component';
import { EvaluationMasterComponent } from './pages/master/evaluation-master/evaluation-master.component';
import { ClassComponent } from './pages/master/class/class.component';
import { ShipComponent } from './pages/master/ship/ship.component';
import { CommitteeComponent } from './pages/master/committee/committee.component';
import { IncubatorComponent } from './pages/master/incubator/incubator.component';
import { VendorMasterComponent } from './pages/master/vendor-master/vendor-master.component';
import { StepMasterComponent } from './pages/master/step-master/step-master.component';
import { MakeIiiTransactionComponent } from './pages/make-iii-transaction/make-iii-transaction.component';
import { TdfTransactionComponent } from './pages/tdf-transaction/tdf-transaction.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { IdexOcTransactionComponent } from './pages/idex-oc-transaction/idex-oc-transaction.component';
import { IdexAditiTransactionComponent } from './pages/idex-aditi-transaction/idex-aditi-transaction.component';
import { IdexFaujiTransactionComponent } from './pages/idex-fauji-transaction/idex-fauji-transaction.component';
import { MasterOverviewComponent } from './pages/master/master-overview/master-overview.component';
import { SectionComponent } from './master/section/section.component';
import { StepPhaseComponent } from './master/step-phase/step-phase.component';
import { DmpComponent } from './components/dmp/dmp.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { RopComponent } from './master/rop/rop.component';
import { SchemeComponentComponent } from './scheme-component/scheme-component.component';
import { DoiDashboardComponent } from './pages/doi-dashboard/doi-dashboard.component';
import { IdexDashboardComponent } from './pages/idex-dashboard/idex-dashboard.component';
import { IdexSchemeListComponent } from './pages/idex-scheme-list/idex-scheme-list.component';
import { RevenueSchemeListComponent } from './pages/revenue-scheme-list/revenue-scheme-list.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { TdfSchemeListComponent } from './pages/tdf-scheme-list/tdf-scheme-list.component';
import { SeekProposalComponent } from './pages/seek-proposal/seek-proposal.component';
import { TdfDashboardComponent } from './pages/tdf-dashboard/tdf-dashboard.component';
import { MonitoringModuleComponent } from './pages/monitoring-module/monitoring-module.component';
import { MilestoneMasterComponent } from './pages/milestone-master/milestone-master.component';
import { RevenueDashbaordComponent } from './pages/revenue-dashbaord/revenue-dashbaord.component';
import { MakeSchemeListComponent } from './pages/make-scheme-list/make-scheme-list.component';
import { MakeDashboardComponent } from './pages/make-dashboard/make-dashboard.component';
import { UploadChallengesComponent } from './pages/upload-challenges/upload-challenges.component';
import { FileManagementRouteComponent } from './pages/file-management-route/file-management-route.component';

import { PILComponent } from './pages/master/pil/pil.component';
import { TestTransactionComponent } from './pages/test-transaction/test-transaction.component';
import { AwardOfContractComponent } from './pages/award-of-contract/award-of-contract.component';
import { FirmResponseSubmissionComponent } from './pages/firm-response-submission/firm-response-submission.component';
import { DrdoAipComponent } from './pages/drdo-aip/drdo-aip.component';
import { NotificationComponent } from './components/notification/notification.component';
import { PrimeTransactionComponent } from './pages/prime-transaction/prime-transaction.component';
import { IndusXTransactionComponent } from './pages/indus-x-transaction/indus-x-transaction.component';
import { VenderSpecficDocumentComponent } from './components/vender-specfic-document/vender-specfic-document.component';
import { FirmResponseEvaluationComponent } from './pages/firm-response-evaluation/firm-response-evaluation.component';
import { PreparationOfPsqrFrommPddComponent } from './pages/preparation-of-psqr-fromm-pdd/preparation-of-psqr-fromm-pdd.component';
import { PsqrToSqrComponent } from './pages/psqr-to-sqr/psqr-to-sqr.component';
import { ConstituteContractNegotiationCommitteeComponent } from './pages/constitute-contract-negotiation-committee/constitute-contract-negotiation-committee.component';
import { UploadHatSatComponent } from './pages/stape-component/upload-hat-sat/upload-hat-sat.component';
import { OcShortlistingComponent } from './pages/idex-scheme-list/oc-shortlisting/oc-shortlisting.component';
import { TechnologyDomainComponent } from './pages/master/technology-domain/technology-domain.component';
import { HigherAuthorityComponent } from './higher-authority/higher-authority.component';
import { CFIComponent } from './pages/master/cfi/cfi.component';
import { TicketManagementComponent } from './pages/ticket-managemnt/ticket-management/ticket-management.component';
import { TaskManagementComponent } from './pages/task-management/task-management.component';
import { CfiTransactionComponent } from './pages/master/cfi/cfi.transaction';
import { PILTransactionComponent } from './pages/master/pil/pil.transaction';
import { CfiMasterComponent } from './pages/master/cfi-master/cfi-master.component';
import { FirmCapacityAssessmentComponent } from './pages/stape-component/firm-capacity-assessment/firm-capacity-assessment.component';
import { NotificationTemplateComponent } from './pages/master/notification-template/notification-template.component';
import { ReviewConnectComponent } from './pages/review-connect/review-connect.component';
import { EvaluationOfEoiComponent } from './pages/evaluation-of-eoi/evaluation-of-eoi.component';
import { ShortlistingOfDasComponent } from './pages/shortlisting-of-das/shortlisting-of-das.component';
import { EventHistoryComponent } from './pages/event-history/event-history.component';
import { LegacyDataComponent } from './pages/legacy-data/legacy-data.component';

// Export the routes constant so it can be imported elsewhere
export const routes: Routes = [
  // Public login route (not guarded)
  { path: 'landing', component: LandingPageComponent },
  { path: 'login', component: LoginComponent },

  {
    path: '',
    canActivateChild: [AuthChildGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'notification', component: NotificationComponent },
      { path: 'tdf/dashboard', component: TdfDashboardComponent },
      { path: 'revenue/dashboard', component: RevenueDashbaordComponent },
      { path: 'revenue/upload-hat-sat', component: UploadHatSatComponent },
      { path: 'revenue/firm-capacity-assessment', component: FirmCapacityAssessmentComponent },
      { path: 'revenue/upload-hat-sat', component: UploadHatSatComponent },
      { path: 'revenue/firm-capacity-assessment', component: FirmCapacityAssessmentComponent },
      { path: 'make/dashboard', component: MakeDashboardComponent },
      { path: 'idex/upload', component: UploadChallengesComponent },
      // { path: 'idex/dadhbaord', component: DoiDashboardComponent },
      { path: 'idex/dashboard', component: IdexDashboardComponent },
      { path: 'idex/monitoring', component: MonitoringModuleComponent },
      { path: 'higher-approval', component: HigherAuthorityComponent },

      { path: 'idex/review', component: FileManagementRouteComponent },
      { path: 'idex/master/milestone', component: MilestoneMasterComponent },
      { path: 'scheme/idex', component: IdexSchemeListComponent },
      { path: 'scheme/revenue', component: RevenueSchemeListComponent },
      { path: 'scheme/tdf', component: TdfSchemeListComponent },
      { path: 'scheme/seek', component: SeekProposalComponent },
      { path: 'scheme/make', component: MakeSchemeListComponent },
      { path: 'table-demo', component: DataTableComponent },
      { path: 'master/user', component: UserDetailsComponent },
      { path: 'master/equipment', component: EquipmentComponent },
      { path: 'master/system', component: SystemComponent },
      { path: 'master/section', component: SectionComponent },
      { path: 'master/scheme', component: SchemeComponent },
      { path: 'master/proposal', component: ProposalComponent },
      { path: 'master/notification-template', component: NotificationTemplateComponent },
      { path: 'scheme', component: SchemeComponentComponent },
      { path: 'dmp', component: DmpComponent },
      { path: 'transaction', component: TransactionComponent },
      { path: 'master', component: MasterOverviewComponent },
      { path: 'master/kmp', component: KmpComponent },
      { path: 'master/unit', component: UnitComponent },
      { path: 'master/class', component: ClassComponent },
      { path: 'master/ship', component: ShipComponent },
      { path: 'master/evaluation', component: EvaluationMasterComponent },
      { path: 'master/committee', component: CommitteeComponent },
      { path: 'master/incubator', component: IncubatorComponent },
      { path: 'cfi-dashboard', component: CFIComponent },
      { path: 'cfi/transaction', component: CfiTransactionComponent },
      { path: 'master/cfi', component: CfiMasterComponent },
      { path: 'pil/transaction', component: PILTransactionComponent },

      { path: 'master/vendor-master', component: VendorMasterComponent },
      { path: 'master/technology-domain', component: TechnologyDomainComponent },
      { path: 'master/phase-master', component: StepPhaseComponent },
      { path: 'master/step-master', component: StepMasterComponent },
      { path: 'master/fund', component: FundComponent },
      { path: 'master/poc', component: PocMasterComponent },
      { path: 'master/rop', component: RopComponent },
      { path: 'master/pil', component: PILComponent },
      { path: 'master/data-master', component: EoiMasterComponent },
      { path: 'proposal-dashboard', component: PropogalDashboardComponent },
      { path: 'setup', component: UserProfileComponent },
      { path: 'user-details', component: UserDetailsComponent },
      { path: 'user-mapping', component: UserMappingComponent },
      { path: 'access-privilege', component: AccessPrivilegeComponent },
      { path: 'idex', component: IdexComponent },
      { path: 'idex-transaction', component: TransactionIdexComponent },
      { path: 'test-transaction', component: TestTransactionComponent },
      { path: 'award-of-contract', component: AwardOfContractComponent },
      { path: 'evaluation-of-eoi', component: EvaluationOfEoiComponent },
      { path: 'shortlisting-of-das', component: ShortlistingOfDasComponent },
      { path: 'firm-response-submission', component: FirmResponseSubmissionComponent },
      { path: 'firm-response-evaluation', component: FirmResponseEvaluationComponent },
      { path: 'preparation-of-psqr-fromm-pdd', component: PreparationOfPsqrFrommPddComponent },
      { path: 'psqr-to-sqr', component: PsqrToSqrComponent },
      { path: 'constitute-contract-negotiation-committee', component: ConstituteContractNegotiationCommitteeComponent },
      { path: 'drdo-aip', component: DrdoAipComponent },
      { path: 'idex-oc-transaction', component: IdexOcTransactionComponent },
      { path: 'oc-shortlisting', component: OcShortlistingComponent },
      { path: 'idex-aditi-transaction', component: IdexAditiTransactionComponent },
      { path: 'idex-fauji-transaction', component: IdexFaujiTransactionComponent },
      { path: 'idex-prime-transaction', component: PrimeTransactionComponent },
      { path: 'idex-indusx-transaction', component: IndusXTransactionComponent },
      { path: 'make-i-transaction', component: MakeITransactionComponent },
      { path: 'make-ii-transaction', component: MakeIiTransactionComponent },
      { path: 'make-iii-transaction', component: MakeIiTransactionComponent },
      { path: 'tdf-transaction', component: TdfTransactionComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'search', component: SearchResultsComponent },
      { path: 'ticket-management', component: TicketManagementComponent },
      { path: 'task-management', component: TaskManagementComponent },
      { path: 'event-history', component: EventHistoryComponent },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: 'review-connect', component: ReviewConnectComponent },
      {
        path: 'upload',
        loadChildren: () =>
          import('./modal/upload/upload.module').then(m => m.UploadModule)
      },
      { path: 'scheme/legacy-data', component: LegacyDataComponent },



    ]
  },
  {
    path: 'vender-specfic-document',
    component: VenderSpecficDocumentComponent
  },
  // Default route → Landing page
  { path: '', redirectTo: '/landing', pathMatch: 'full' },

  // Wildcard → redirect unknown routes to dashboard instead of landing
  { path: '**', redirectTo: '/dashboard' },

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
